import { Box, Skeleton, Stack } from '@mui/material'

export const TimeSlotSkeleton = ({ index = 0 }) => (
  <Box
    sx={{
      mb: 2,
      display: 'flex',
      gap: 2,
      flexWrap: 'wrap',
      padding: 2.5,
      borderRadius: 2,
      backgroundColor: 'secondary.main',
      justifyContent: 'flex-start',
      flexDirection: { xs: 'column', md: 'row' },
      alignItems: { xs: 'stretch', md: 'center' },
      animation: `fadeInExpand 0.4s ease-out ${index * 0.1}s both`,
      '@keyframes fadeInExpand': {
        from: {
          opacity: 0,
          transform: 'translateY(-20px) scale(0.95)',
          maxHeight: 0,
          marginBottom: 0,
        },
        to: {
          opacity: 1,
          transform: 'translateY(0) scale(1)',
          maxHeight: '200px',
          marginBottom: '16px',
        },
      },
    }}
  >
    <Skeleton
      variant='text'
      width={140}
      height={28}
      sx={{ minWidth: '140px' }}
    />
    <Stack
      direction='row'
      sx={{ flexWrap: 'wrap', gap: 1, width: { xs: '100%', md: 'auto' } }}
    >
      <Skeleton variant='rounded' width={160} height={44} />
      <Skeleton variant='rounded' width={160} height={44} />
      <Skeleton variant='rounded' width={160} height={44} />
    </Stack>
  </Box>
)

export const ScheduleDonationSkeleton = () => (
  <Box
    sx={{
      mt: 4,
      px: { xs: 1.5, md: 2 },
      maxHeight: { xs: '500px', md: '500px' },
      overflowY: 'auto',
    }}
  >
    {[1, 2, 3, 4, 5].map(item => (
      <TimeSlotSkeleton key={item} index={item - 1} />
    ))}
  </Box>
)
